// src/app/rootReducer.js
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice'; 
import kidAuthReducer from '../features/auth/kidAuthSlice'; 
import themeReducer from  '../features/theme/themeSlice';
import layoutReducer from "../features/layout/layoutSlice";
import classSectionReducer from "../features/classSection/classSectionSlice";
import classPeriodsReducer from "../features/classPeriod/classPeriodsSlice";
import getAllClassPeriodTeacherscheduleReducer from "../features/classPeriodTeacherschedule/classPeriodTeacherscheduleSlice" 
import getAllClassSubjectMappingReducer from  "../features/classSubject/classSubjectMappingSlice"
import getAllClassWithSectionsDetailsReducer from "../features/classWithSeSSubDetails/classWithSectionDetailsListSlice"
import getAllClasswithStrSubsSecReducer from "../features/classWithStreamSubStreamSection/classWithStreamSubStreamSectionListSlice"
import getAllSubjectBasedTeachersReducer from '../features/subjectBasedTeachers/subjectBasedTeachersSlice'
import classReducer from "../features/class/classSlice";
import assignedFeeStructure from "../features/assignFeetoClass/assignFeesStructureToClassSlice";
import schoolProfileReducer from "../features/schoolProfile/schoolProfileSlice";
import academicYearReducer from '../features/academicYear/academicYearSlice';
import addStudentAcadYearReducer from '../features/academicYear/addStudentAcadYearSlice';
import selectedSchoolReducer from '../features/schoolProfile/selectedSchoolSlice';
import academicYearListReducer from '../features/academicYear/academicYearListSlice';
import menuReducer from '../features/SidebarMenu/menuSlice';
import staffReducer from '../features/Staff/staffSlice';
import notificationReducer from '../features/notifications/notificationSlice';

import dynamicTableReducer from '../features/filterRedux/dynamicTableSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  parentKidAuth: kidAuthReducer,
  theme: themeReducer,
  layout: layoutReducer,
  classSection: classSectionReducer,
  classPeriods: classPeriodsReducer,
  classWithSectionsDetails : getAllClassWithSectionsDetailsReducer,
  allClassPeriodTeacherscheduleList: getAllClassPeriodTeacherscheduleReducer,
  class: classReducer,
  allClasswithStrSubsSeclist: getAllClasswithStrSubsSecReducer,
  classSubjectMappingList : getAllClassSubjectMappingReducer,
  subjectBasedTeachers : getAllSubjectBasedTeachersReducer,
  assignFeeStructureToClass : assignedFeeStructure,
  schoolProfile: schoolProfileReducer,
  selectedSchool: selectedSchoolReducer,
  academicYear: academicYearReducer,
  academicYearList: academicYearListReducer,
  addStudentAcadYear: addStudentAcadYearReducer,
  menu: menuReducer,
  staff: staffReducer,
  notification: notificationReducer,

  dynamicTables: dynamicTableReducer,
  // Add more feature reducers here
});

export default rootReducer;
